import {WebSvg} from '@/assets';
import Modal from 'react-bootstrap/Modal';
import {RenderIf} from '../helpers';

interface Props {
  visible: boolean;
  close: () => void;
  url?: string;
  description?: string;
}

function HelpVideoModal(props: Props) {
  return (
    <Modal
      className="step-video"
      show={props.visible}
      onHide={props.close}
      size="lg"
      centered={true}
    >
      <Modal.Body>
        <div className="embed-responsive embed-responsive-21by9">
          <img
            src={WebSvg.SolidCross}
            onClick={props.close}
            className="close-button"
          />
          <RenderIf condition={props.url}>
            <iframe
              src={props.url}
              width="100%"
              height="500"
              allow="autoplay"
            ></iframe>
          </RenderIf>
          <RenderIf condition={props.description}>
            <div className="text-center p-4 fs-3 bg-white fw-medium">
              {props.description}
            </div>
          </RenderIf>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default HelpVideoModal;
